const STORAGE_KEY = "ignaScout.dashboardTableState";

/** Fired when the header logo is clicked while already on the dashboard. */
export const DASHBOARD_RESET_EVENT = "ignaScout:dashboard-reset";

export const DEFAULT_ROWS_PER_PAGE = 5;
export const ALLOWED_ROWS_PER_PAGE = [5, 10, 25];

const DEFAULT_STATE = {
  page: 0,
  rowsPerPage: DEFAULT_ROWS_PER_PAGE,
  statusFilter: "",
  jobTitleFilter: "",
  nameQuery: "",
  fromDashboard: false,
};

export const loadDashboardTableState = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_STATE };

    const parsed = JSON.parse(raw);
    const page = Number.isFinite(parsed?.page) && parsed.page >= 0 ? parsed.page : 0;
    const rowsPerPage = ALLOWED_ROWS_PER_PAGE.includes(parsed?.rowsPerPage)
      ? parsed.rowsPerPage
      : DEFAULT_ROWS_PER_PAGE;

    return {
      page,
      rowsPerPage,
      statusFilter: typeof parsed?.statusFilter === "string" ? parsed.statusFilter : "",
      jobTitleFilter: typeof parsed?.jobTitleFilter === "string" ? parsed.jobTitleFilter : "",
      nameQuery: typeof parsed?.nameQuery === "string" ? parsed.nameQuery : "",
      fromDashboard: parsed?.fromDashboard === true,
    };
  } catch {
    return { ...DEFAULT_STATE };
  }
};

export const saveDashboardTableState = (state) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        page: state.page ?? 0,
        rowsPerPage: state.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE,
        statusFilter: state.statusFilter ?? "",
        jobTitleFilter: state.jobTitleFilter ?? "",
        nameQuery: state.nameQuery ?? "",
        fromDashboard: state.fromDashboard === true,
      }),
    );
  } catch {
    // ignore storage errors
  }
};

export const clearDashboardTableState = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
